"use client";

import Image from "next/image";
import { useRouter } from "next/navigation";
import { MessageIcon } from "../ui/message-icon";
import { BOOKMARK_CATEGORIES } from "@/lib/api/public-client";
import Link from "@/components/ui/Link";
import { getTimeAgo } from '@/lib/componentutills';

type FieldConfig = {
  hidden?: boolean;
  value?: string;
  customClass?: string;
};

type Props = {
  title?: FieldConfig;
  excerpt?: FieldConfig;
  timeAgo?: FieldConfig;
  slug?: string;
};

export const VerticalMediumDescNews = ({
  title = { hidden: false, value: "கே.எல்.ராகுலுக்கு வெற்றிகரமான அறுவை சிகிச்சை செய்யப்பட்டது, அவர் திரும்பி வருவதில் உறுதியாக", customClass: "" },
  excerpt = { hidden: false, value: "தாரக் மேத்தா கா ஊல்தா சாஷ்மா படத்தின் தயாரிப்பாளர் அசித் குமார் மோடி சமீப காலமாக பல குற்றச்சாட்டுகளை சந்தித்து வருகிறார். ஜெனிபர் மிஸ்திரி", customClass: "" },
  timeAgo = { hidden: false, value: "May 17, 2023", customClass: "" },
  slug,
}: Props) => {
  const router = useRouter();

  const titleValue = title?.value || "";
  const excerptValue = excerpt?.value || "";
  const timeAgoValue = getTimeAgo(timeAgo?.value);

  const handleCardClick = () => {
    if (slug) {
      router.push(`/${slug}`);
    }
  };
  return (
    <Link href={`/${slug}`} className="block  transition-colors cursor-pointer"
    >
      <div
        className={`flex flex-col bg-F8F8F8 overflow-hidden p-4 gap-4 ${slug ? "cursor-pointer" : ""
          }`}

      >
        {/* CONTENT */}
        <div className="flex flex-col gap-3">
          {/* Title */}
          {!title?.hidden && (
 <h3 className={`text-16-tamil-700 leading-[1.4] text-1B1B1B h-auto ${title?.customClass || ""}`}>
              {titleValue}
            </h3>
          )}

          {/* Description */}
          {!excerpt?.hidden && (
            <p className={`text-12-tamil-400 text-4D4D4D leading-relaxed line-clamp-4 h-auto ${excerpt?.customClass || ""}`}>
              {excerptValue}
            </p>
          )}

          {/* Footer */}
          <div className="flex justify-between items-center gap-3">
            {!timeAgo?.hidden && (
              <span className={`text-12-tamil-500 ${timeAgo?.customClass || ""}`}>{timeAgoValue}</span>
            )}
            <div className="flex gap-3" onClick={(e) => e.stopPropagation()}>
              <MessageIcon
                id="message-icon-3"
                slug={slug}
                category={BOOKMARK_CATEGORIES.NEWS}
                title={titleValue}
                description={excerptValue}
                articleUrl={slug ? `/${slug}` : undefined}
              />
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};